import { AwsConfig as AwsConstants } from './Constants';

import BaseService, { RequestInterface } from './Base';
import BasePaginationQuery from '@interfaces/base-pagination-query';
import IPagination from '@interfaces/IPagination';
import { IUser } from '@interfaces/IUser';

export default class ManagerService extends BaseService {
    constructor() {
        super(AwsConstants.API_CONFIG, 'user-manager');
    }
    async paging(query: BasePaginationQuery, fields?: string[]): Promise<IPagination<IUser>> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        if (query.limit) {
            params.queryStringParameters['limit'] = query.limit;
        }
        if (query.offset) {
            params.queryStringParameters['offset'] = query.offset;
        }
        if (query.search) {
            params.queryStringParameters['search'] = query.search;
        }

        const res = await super.get<IPagination<IUser>>('', params);
        return res;
    }
    async getById(id: string, fields?: string[]): Promise<IUser> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        const res = await super.get<IUser>(id, params);
        return res;
    }

    async ListUserById(id: string, fields?: string[]): Promise<IUser> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        const res = await super.get<IUser>(`${id}/user`, params);
        return res;
    }
    async create(id: string): Promise<IUser> {
        const res = await super.post<IUser>(id);
        return res;
    }

    async deleteById(id: string): Promise<void> {
        await super.delete<void>(id);
    }

    async userAdd(id: string, user: string): Promise<IUser> {
        const params: RequestInterface = {
            body: user
        };
        const res = await super.patch<IUser>(`${id}/user/${user}`, params);
        return res;
    }

    async userRemove (id: string, userId: string): Promise<void> {
        await super.delete<void>(`${id}/user/${userId}`);
    }

}
